module.exports = __webpack_public_path__ + "static/img/nc123.3e08897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nc123.jpg
// module id = /q0Y
// module chunks = 73